import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export type DownloadTradesJob = {
  pairId: number;
  downloadStateId: number | null;
  downloadFileId: number | null;
  status: string | null;
  startedAt: string;
};

type DownloadTradesState = {
  jobs: Record<number, DownloadTradesJob>;
};

type DownloadTradesActions = {
  setJob: (pairId: number, job: DownloadTradesJob) => void;
  updateJob: (pairId: number, patch: Partial<DownloadTradesJob>) => void;
  clearJob: (pairId: number) => void;
  getJob: (pairId: number) => DownloadTradesJob | undefined;
};

const downloadTradesSlice: StateCreator<DownloadTradesState & DownloadTradesActions> = (
  set,
  get,
) => ({
  jobs: {},

  setJob: (pairId, job) =>
    set(state => ({
      jobs: { ...state.jobs, [pairId]: job },
    })),

  updateJob: (pairId, patch) =>
    set(state => {
      const current = state.jobs[pairId];
      if (!current) return state;
      return { jobs: { ...state.jobs, [pairId]: { ...current, ...patch } } };
    }),

  clearJob: pairId =>
    set(state => {
      const next = { ...state.jobs };
      delete next[pairId];
      return { jobs: next };
    }),

  getJob: pairId => get().jobs[pairId],
});

const persistedDownloadTradesStore = persist<DownloadTradesState & DownloadTradesActions>(
  downloadTradesSlice,
  {
    name: `${window.location.origin}/download-trades`,
  },
);

export const useDownloadTradesStore = create(persistedDownloadTradesStore);
